import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import { ChevronRight, ChevronLeft } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    paper: ({ fullScreen }) => ({
        width: fullScreen ? '100%' : 'auto'
    }),
    list: () => ({
        minWidth: '50%',
        maxWidth: '100%'
    }),
    closeButton: ({ anchor }) => ({
        position: 'fixed',
        [anchor]: theme.spacing(2),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    })
}));

const TemporaryDrawer = ({ open, setOpen, component, width, anchor = 'left', fullScreen = false }) => {
    const { list, closeButton, paper } = useStyles({ width, anchor, fullScreen });

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };

    return (
        <Drawer
            open={open}
            onClose={toggleDrawer(false)}
            anchor={anchor}
            classes={{ paper }}
        >
            <div className={list} role="presentation">
                <List>
                    <IconButton aria-label="close" className={closeButton} onClick={toggleDrawer(false)} tabIndex={-1}>
                        { anchor === 'left' ? <ChevronLeft /> : <ChevronRight/> }
                    </IconButton>
                    { component }
                </List>
            </div>
        </Drawer>
  );
}

TemporaryDrawer.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    component: PropTypes.object,
    anchor: PropTypes.string,
    width: PropTypes.number,
    fullScreen: PropTypes.bool
}

export default TemporaryDrawer;
